import * as moment from 'moment';

export function toISOString(date: Date) {
  return moment(date).format();
}
